import { render, staticRenderFns } from "./TransferOutCampaigns.vue?vue&type=template&id=5c0987a8&scoped=true"
import script from "./TransferOutCampaigns.vue?vue&type=script&lang=ts"
export * from "./TransferOutCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./TransferOutCampaigns.vue?vue&type=style&index=0&id=5c0987a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0987a8",
  null
  
)

export default component.exports